import Vue from "vue";
import Router from "vue-router";
//引入多语言支持
import i18n from "@/tools/i18n";
import { userLang } from '@/plugs';

Vue.use(Router);

const Register = () => import("./view/Register.vue");
const About = () => import("./view/About.vue");
const Upload = () => import("./components/Upload.vue");

let lang = userLang;
if (lang == "zh") {
  i18n.locale = "zh_CN";
}

const router = new Router({
  mode: "history",
  base: "/app-article/",
  routes: [
    {
      path: "/",
      component: Register,
      meta: {
        title: i18n.t("appArticle.registerText")
      }
    },
    {
      path: "/about",
      component: About,
      meta: {
        title: i18n.t("appArticle.aboutUsText")
      }
    },
    {
      path: "/upload",
      component: Upload,
      meta: {
        title: i18n.t("appArticle.uploadText")
      }
    }
  ]
});

router.beforeEach(function(to, from, next) {
  document.title = to.meta.title || "";
  next();
});

export default router;
